export default {
  en: {
    title: 'New words',
    undo: 'Undo last answer',
    cardLabel: 'Card',
    preparingCards: 'Preparing cards',
    doneTitle: 'Done',
    allLearnedTitle: 'No new words left',
    nothingTitle: 'Nothing to learn',
    allLearnedBody: 'All words are already in progress',
    nothingBody: 'Add words in "Common dictionaries" or "My dictionaries" — they will show up here.',
    unsavedWarning: 'Some answers were not saved ({{count}}) — a network hiccup, these words will come back.',
    review: 'Review',
    backToDictionaries: 'To dictionaries',
  },
  ru: {
    title: 'Новые слова',
    undo: 'Отменить последнюю оценку',
    cardLabel: 'Карточка',
    preparingCards: 'Готовлю карточки',
    doneTitle: 'Готово',
    allLearnedTitle: 'Новых слов не осталось',
    nothingTitle: 'Нечего учить',
    allLearnedBody: 'Все слова уже в изучении',
    nothingBody: 'Возьми слова в «Общих словарях» или «Моих словарях» — они появятся здесь.',
    unsavedWarning: 'Часть ответов не сохранилась ({{count}}) — сеть подвела, эти слова придут снова.',
    review: 'Повторять',
    backToDictionaries: 'В словари',
  },
};
